import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import {
    ReviewsPageBody,
    renderContentBlock,
} from "../components/ReviewsPageBody";

// Mutable reactivated props (not Immutable<>): PageSkeleton composes the in-tree
// SiteHeader chain, which is typed with mutable reactivated props.
export const Template = (
    props: templates.ReviewsPageDocumentTemplate,
): React.JSX.Element => {
    const { show_sources, footer_content } = props;

    return (
        <PageSkeleton
            pageChrome={props.page_chrome}
            // Standalone widget (show_sources=false) swaps the site chrome for a
            // bare <header> and a standalone footer. They render in the
            // header/footer slots so they stay siblings of <main> under .layout,
            // which the puppeteer chrome selectors depend on.
            header={show_sources ? undefined : <header></header>}
            footer={
                show_sources ? undefined : (
                    <div className="reviews-standalone-footer">
                        <div className="reviews-standalone-footer__container l-capped-width">
                            {footer_content.map(renderContentBlock)}
                        </div>
                    </div>
                )
            }
        >
            <ReviewsPageBody {...props} />
        </PageSkeleton>
    );
};
